<template>
  <div class="home">
    <my-header :activeNum='type' style="z-index:1" :change='changeTitle' v-if='flag1'></my-header>

    <div class="titCon" v-if='type==1'>
        <div class='tit' :class='{"active":i==2}' @click='change(2)'>推荐</div> 
        <div class='tit' :class='{"active":i==0}' @click='change(0)'>最近</div> 
        <div class='tit' :class='{"active":i==1}' @click='change(1)'>热门</div> 
    </div>
    <transition>
      <div class="contain" v-if='type==1'>
    
      <div class="item" v-for='(item,i) in list' :key='i' v-if='flag' @click='goDetail(item)'>
        <div class="backImg" :style='{"background":"url("+item.sceneCover+")no-repeat center/cover"}'></div>
        <h3 class='subtit'>{{item.sceneName}}</h3>
        <div class='bot'>
          <span>{{item.sceneContext!=null?item.sceneContext.substr(0,7):'无'}}</span>
          <span class='sceneType' v-for='(item1,j) in items' :key='j' v-if='item1.id==item.labelID'>{{item1.name}}</span>
        </div>
      </div>
    
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
    </div>
    <!-- 全景图片 -->
    <div class="contain" v-if='type==2'>
    
      <div class="item" v-for='(item,i) in list' :key='i' v-if='flag' @click='goDetail(item)'>
        <div class="backImg" :style='{"background":"url("+item.sceneCover+")no-repeat center/cover"}'></div>
        <h3 class='subtit'>{{item.sceneName}}</h3>
        <div class='bot'>
          <span>{{item.sceneContext!=null?item.sceneContext.substr(0,7):'无'}}</span>
          <span class='sceneType' v-for='(item1,j) in items' :key='j' v-if='item1.id==item.labelID'>{{item1.name}}</span>
        </div>
      </div>
    
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
    </div>
<!-- 全景图片 -->
<!-- 全景视频 -->
      <div class="contain" v-if='type==3'>
    
      <div class="item" v-for='(item,i) in list' :key='i' v-if='flag'>
        <div class="backImg" :style='{"background":"url("+item.sceneCover+")no-repeat center/cover"}'></div>
        <h3 class='subtit'>{{item.sceneName}}</h3>
        <div class='bot'>
          <span>{{item.sceneContext!=null?item.sceneContext.substr(0,7):'无'}}</span>
          <span class='sceneType' v-for='(item1,j) in items' :key='j' v-if='item1.id==item.labelID'>{{item1.name}}</span>
        </div>
      </div>
    
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
      <div class="itemBox"></div>
    </div>
    <!-- 全景视频 -->
    </transition>
    <el-pagination style="margin-top:100px;position:relative;left:50%;transform:translateX(-50%);text-align:center;margin-bottom:20px"
    @current-change="handleCurrentChange"
    background
    :page-size="16"
    layout="prev, pager, next"
    :total="count">
    </el-pagination>
  </div>
</template>
<style scoped>
 .v-enter, .v-leave-to {
    opacity: 0;
  
  
}
.v-enter-active,
        .v-leave-active {
            transition: all 0.4s ease;
        }
.changeIndex{
  position: absolute;
  top:-30px;
  right:90px;
  cursor: pointer;
}
.more{
  position: absolute;
  top:-30px;
  right:10px;
    cursor: pointer;
}
.active{
  border-bottom:4px solid gray;
  box-sizing: border-box;
}
 .home{
   background-color:white;
   min-width: 1200px;
 }
 .titCon{
   text-align: center;
   width: 1200px;
   position: relative;
   left: 50%;
   transform: translateX(-50%);
   border-bottom:1px solid gray
 }
 .tit{
    display: inline-block;
    width: 200px;
    padding-bottom: 60px;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    cursor: pointer;
    height: 60px;
    line-height: 60px;
 }

 .logo{
   width: 400px;
   height: 46px;
   position: absolute;
   left:50%;
   top:50%;
   transform: translate(-50%,-50%);
 }
 .subtit{
   margin-top: 10px;
 }
 .sceneType{
   position: absolute;
   right:0
 }
 .bot{
   position: relative;
   top:10px
 }
 .backImg{
   width: 280px;
   height: 280px;
   position: relative;
   top:0
 }
 .panoExample{
   height: 730px;
   width: 100%;
   margin-top: -60px;
  position: relative;
 }
 
 .contain{
   width: 1180px;
   min-height:716px;
   display: flex;
   justify-content: space-around;
   flex-wrap: wrap;
   position: relative;
   left:50%;
   transform: translateX(-50%);
   top:80px
 }
 .item{
   width: 280px;
   height: 337px;

 }
 .itemBox{
   width: 280px;
   height: 0;
 }
</style>
<script>
import https from '../https.js'
import MyHeader from "../components/header2.vue";
export default {
  name: "",
  components: {
     MyHeader: MyHeader,
  },
  data() {
    return {
      list:[],
      items:[{name:'风光',id:"204f02da-36e3-4c27-ad1f-d454d0d1ded2"},{name:'村落',id:"395f7cef-a6c8-47de-b65f-539c477c31c2"},{name:'景区',id:"a35e92a2-0601-4ee4-9b73-dcc2e86cb359"
},{name:'商业案例',id:'64ddf1ff-e1f5-445c-ade4-0e9f88091fdf'},{name:'纪实',id:"33491ac3-bc56-4920-bf3b-12b0ea4cda52"
},{name:'高校',id:"52607ac7-c51d-43c4-bde2-643e63594d13"},{name:'城市',id:"40e0229f-bd10-47d2-a2ca-275becd12a8d"},{name:'3D设计',id:"414b931f-3f52-4750-ae21-d30a398e1fc6"
},{name:'汽车',id:"c1094d54-e865-4510-b42f-4d876da82d1b"},{name:'建筑',id:"b767f942-1e10-461f-971c-1c87ca76b761"}],
 src:'./images/bg.png',
      src1:'./images/logo.png',
      i:0,
      count:0,
      num1:1,
      num2:1,
      flag:false,
      flag1:false,
      type:1
    }
    
  },
  created() {
    
  },
  mounted(){
     console.log(this.$route.query.type)
     this.type=this.$route.query.type
     this.flag1 = true
     if(this.$route.query.type==1){
         this.getPublicList(0,1)
         this.type=1
     }
     else if(this.$route.query.type==2){
        this.getquanjingPicture(0,1)
         this.type=2
     }
     else{
        this.getquanjingVideo(0,1)
         this.type=3
     }
  },
  methods: {
      goDetail(item){
      if(item.modelID==null){
         this.$router.push({path:'/previewwidthoutmodel',query:{id:item.id}})
      }
      else{
         this.$router.push({path:'/preview',query:{id:item.id}})
      }
    },
      changeTitle(i){
      if(i==1){
        this.getPublicList(0,1)
        this.type=1
      }
      else if(i==2){
        this.getquanjingPicture(0,1)
        this.type=2
      }
      else{
        this.getquanjingVideo(0,1)
        this.type=3
      }
    },
      handleCurrentChange(val){
          console.log(val)
          if(this.type==1){
                this.getPublicList(0,val)
          }
          else if(this.type==2){
              this.getquanjingPicture(0,val)
          }
          else {
              this.getquanjingVideo(0,val)
          }
      },
    change(i){
      if(i==2){
       this.list = []
       this.i = i
     }else{
        console.log(i)
      this.i = i
      this.getPublicList(i,1)
     }
    },
    getMore(){
     
    },
    changeIndex(){
      console.log(this.num1)
      if((this.i==0)&&(this.num1==Math.ceil(this.count/8))){
        this.num1 = (this.num1+1)%(Math.ceil(this.count/8))
         this.getPublicList(0,this.num1)
      }
      else if((this.i==0)&&(this.num1!=Math.ceil(this.count/8))){
        this.num1 = this.num1+1
        this.getPublicList(0,this.num1)
      }
      else if((this.i==1)&&(this.num2==Math.ceil(this.count/8))){
        this.num2 = (this.num2+1)%(Math.ceil(this.count/8))
         this.getPublicList(0,this.num2)
      }
      else if((this.i==1)&&(this.num2!=Math.ceil(this.count/8))){
        this.num2 = this.num2+1
        this.getPublicList(0,this.num2)
      }
    },
    getPublicList(i,j){
      this.flag = false
        https
        .fetchGet('/api/Scene/GetPublic', {
         pageIndex: j,
         pageSize: 16,
         option: i,
         type:1
        })
        .then(res => {
          console.log(res.data)
          this.list = res.data.result
          this.count = res.data.count
           this.flag = true
        })
    },
    getquanjingPicture(i,j){
        https
        .fetchGet('/api/Scene/GetPublic', {
         pageIndex: j,
         pageSize: 16,
         option: i,
         type:1
        })
        .then(res => {
          console.log(res.data)
          this.list = res.data.result
          this.count = res.data.count
           this.flag = true
        })
    },
     getquanjingVideo(i,j){
         https
        .fetchGet('/api/Scene/GetPublic', {
         pageIndex: j,
         pageSize: 16,
         option: i,
         type:2
        })
        .then(res => {
          console.log(res.data)
          this.list = res.data.result
          this.count = res.data.count
           this.flag = true
        })
    },
  }
};
</script>
